import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.green1};
  border: 1px solid ${({ theme }) => theme.colors.green2};
  border-radius: 12px;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.p`
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: ${({ theme }) => theme.colors.black9};
  margin: 0;
`;

export const Description = styled.p`
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black9};
  margin: 0;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 12px;
`;
